import { render, staticRenderFns } from "./StartForm20.vue?vue&type=template&id=7b9c8321&scoped=true"
import script from "./StartForm20.vue?vue&type=script&lang=ts"
export * from "./StartForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c8321",
  null
  
)

export default component.exports